import React from 'react'

const TeamMember = ({ name, role }) => {
	return (
		<div className="container">
			<div className="field name">{name}</div>
			<div className="field role">{role}</div>
			<style jsx>{`
				.container {
					padding-right: 1.25rem;
					margin-bottom: 1.25rem;
				}
				.field {
					font-family: 'Elizeth';
				}
				.name {
					font-size: 20px;
					margin-bottom: 0.3125rem;
				}
				.role {
					font-size: 12px;
					line-height: 16px;
				}
			`}</style>
		</div>
	)
}

export default TeamMember
